/**
 * The lamp drawing family — the ids `LightAnimation.vue` draws.
 *
 * The hub declares `settings.light_type` on its lighting classes; a device saved
 * before that keeps the choice in its icon/name, which `lightKindOf` still reads.
 */
import { lightKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const LIGHT_VARIANTS: VariantFamily = {
  drawing: 'light',
  settingKey: 'light_type',
  title: ['Light fitting', 'Svetilo'],
  description: [
    'Where this light is fitted. The tile draws the fitting; nothing else changes.',
    'Kam je to svetilo vgrajeno. Ploščica nariše svetilo; drugo se ne spremeni.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic — from the name', 'Samodejno — po imenu'] },
    { value: 'ceiling', icon: 'light', label: ['Ceiling (flush)', 'Stropna svetilka'] },
    { value: 'pendant', icon: 'dine_lamp', label: ['Pendant', 'Viseča svetilka'] },
    { value: 'chandelier', icon: 'light_group', label: ['Chandelier', 'Luster'] },
    { value: 'linear', icon: 'linear_scale', label: ['Suspended linear', 'Linearna svetilka'] },
    { value: 'circular', icon: 'circle', label: ['Ring', 'Obroč'] },
    { value: 'panel', icon: 'crop_square', label: ['Ceiling panel', 'Stropna plošča'] },
    { value: 'downlight', icon: 'highlight', label: ['Recessed downlight', 'Vgradna svetilka'] },
    { value: 'spot', icon: 'light_mode', label: ['Track spot', 'Reflektor na tirnici'] },
    { value: 'wall', icon: 'wall_lamp', label: ['Wall sconce', 'Stenska svetilka'] },
    { value: 'table', icon: 'table_lamp', label: ['Table lamp', 'Namizna svetilka'] },
    { value: 'floor', icon: 'floor_lamp', label: ['Floor lamp', 'Talna svetilka'] },
    { value: 'strip', icon: 'lightstrip', label: ['LED strip', 'LED trak'] },
  ],
  defaultValue: 'auto',
  resolve: (device) =>
    variantFromSetting(device.settings, 'light_type', variantValues(LIGHT_VARIANTS)) ?? lightKindOf(device),
};
